import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { MainLayout } from "components/layouts";
import { Breadcrumb, ConfigProvider, Flex, Space, Tabs } from "antd";
import { useSelector } from "react-redux";
import UserList from "../pages/UserList";
import UserRole from "../pages/UserRole";
import UserPermission from "../pages/UserPermission";
import { useState } from "react";

function UserManagement() {
  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const [selectedMenu, setSelectedMenu] = useState('userManage_userList');

  const menuBreadcrumbMapping = {
    'userManage_userList': t('user_list.header'),
    'userManage_userRole': t('role.header'),
    'userManage_permission': t('permission.header')
  }

  const handleTabChange = (key) => {
    setSelectedMenu(key);
  };

  return (
    <MainLayout>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("user_management.header"), href: "" },
            { title: menuBreadcrumbMapping[selectedMenu] || null, }
          ]} />
          <h2>{menuBreadcrumbMapping[selectedMenu] || t("user_management.header")}</h2>
        </Flex>
        <ConfigProvider
          theme={{
            components: {
              Tabs: {
                itemHoverColor: "var(--tab-color)",
                itemActiveColor: "var(--tab-color)"
              },
            },
          }}
        >
          <Tabs destroyInactiveTabPane={true} defaultActiveKey="userManage_userList" onChange={handleTabChange}>
            {
              roles.includes("ACCESS_USER_MANAGEMENT|USER_LIST") &&
              <Tabs.TabPane tab={t('user_list.header')} key="userManage_userList">
                <UserList />
              </Tabs.TabPane>
            }
            {
              roles.includes("ACCESS_USER_MANAGEMENT|ROLE") &&
              <Tabs.TabPane tab={t('role.header')} key="userManage_userRole">
                <UserRole />
              </Tabs.TabPane>
            }
            {
              roles.includes("ACCESS_USER_MANAGEMENT|PERMISSION") &&
              <Tabs.TabPane tab={t('permission.header')} key="userManage_permission">
                <UserPermission />
              </Tabs.TabPane>
            }
          </Tabs>
        </ConfigProvider>

        {/* <Outlet /> */}
      </Space>
    </MainLayout>
  );
}

export default UserManagement;
